module.exports = __webpack_public_path__ + "media/src/images/landing/circuitpython-logo-words-09128568074e048424a5926be7a799e9.png";